module.exports = __webpack_public_path__ + "static/calatonStudioMobile@2x-3a8fe2eb08645def68136fb1c154abc3.jpg";